import { Copy } from '../i18n';
import { HAS_FACTORY } from '../config';
import { formatAddress } from '../lib/format';
import { RiskNote } from '../ui/RiskNote';
import { offerHomeScreen, webApp } from '../telegram/webapp';

export function HomeScreen({
  copy,
  connected,
  recent,
  onLaunch,
  onOpen,
  onDemo,
  onSettings,
}: {
  copy: Copy;
  connected: boolean;
  recent: string[];
  onLaunch: () => void;
  onOpen: (address: string) => void;
  onDemo: () => void;
  onSettings: () => void;
}) {
  return (
    <div className="scroll">
      {!connected ? <div className="banner">{copy.walletNeeded}</div> : null}
      {!HAS_FACTORY ? <div className="banner warn">{copy.noFactory}</div> : null}

      <section className="launchpad-hero"><span className="eyebrow">СОЗДАЙТЕ СВОЁ СООБЩЕСТВО</span>
        <h2>От идеи<br />до своего токена.</h2><p>Запустите токен, привяжите канал и чат. Карточка с паспортом появится автоматически.</p></section>

      <div className="btn-row">
        <button type="button" className="btn" onClick={onLaunch}>
          {copy.launchToken}
        </button>
        <button type="button" className="btn secondary" onClick={onDemo}>
          {copy.demoToken}
        </button>
      </div>
      <div className="btn-row">
        <button type="button" className="btn secondary" onClick={onSettings}>Уведомления</button>
      </div>
      <div className="chips"><button className="chip" onClick={offerHomeScreen}>На домашний экран</button>
        {webApp()?.isVersionAtLeast('8.0') && webApp()?.requestFullscreen ? <button className="chip" onClick={() => webApp()?.requestFullscreen?.()}>Полный экран</button> : null}</div>

      <OpenForm copy={copy} onOpen={onOpen} />

      {recent.length > 0 ? (
        <>
          <div className="section-label">{copy.recent}</div>
          <div className="group">
            {recent.map((address) => (
              <button
                key={address}
                type="button"
                className="cell"
                style={{ width: '100%', border: 0, background: 'transparent', textAlign: 'left' }}
                onClick={() => onOpen(address)}
              >
                <span className="label">{copy.openToken}</span>
                <span className="value">{formatAddress(address)}</span>
              </button>
            ))}
          </div>
        </>
      ) : null}

      <RiskNote copy={copy} />
    </div>
  );
}

function OpenForm({ copy, onOpen }: { copy: Copy; onOpen: (address: string) => void }) {
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const address = String(data.get('address') ?? '').trim();
        if (address) {
          onOpen(address);
        }
      }}
    >
      <div className="section-label">{copy.openToken}</div>
      <div className="group">
        <div className="field">
          <label htmlFor="curve-address">{copy.pasteAddress}</label>
          <input id="curve-address" name="address" autoComplete="off" placeholder="EQ…" />
        </div>
      </div>
      <p className="hint">{copy.pasteAddressHint}</p>
      <div className="btn-row">
        <button type="submit" className="btn secondary">
          {copy.openToken}
        </button>
      </div>
    </form>
  );
}
